import { render, staticRenderFns } from "./ExemptForm.vue?vue&type=template&id=388a7c86"
import script from "./ExemptForm.vue?vue&type=script&lang=js"
export * from "./ExemptForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports